<template>
  <div class="donor-social-networks">
    <b-button
      class="float-right"
      @click="editRow(-1)"
      right
      size="sm"
      variant="primary"
    >
      <font-awesome-icon icon="plus" />{{ $t("Добавить") }}
    </b-button>
    <table
      class="table-striped table mb-0 dx-g-bs4-overflow-hidden dx-g-bs4-table"
    >
      <thead>
        <tr>
          <th v-if="!isReadonly" class="edit-cell"></th>
          <th>Социальная сеть</th>
          <th>Url</th>
          <th>Комментарий</th>
          <th v-if="!isReadonly" class="delete-cell"></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="data && data.length > 0">
          <tr
            v-for="(row, index) in data"
            :key="'phone-row-' + index + '-' + renderKey"
          >
            <td v-if="!isReadonly">
              <a class="edit" @click="editRow(index)" href="javascript:void(0)">
                <i class="fa fa-pencil-alt"></i>
              </a>
            </td>
            <td>{{ row.social_network_name }}</td>
            <td>{{ row.url }}</td>
            <td>{{ row.commentary }}</td>
            <td v-if="!isReadonly">
              <a
                class="delete"
                @click="deleteRow(data, index)"
                href="javascript:void(0)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="!isReadonly ? 5 : 3" class="text-center">Нет данных</td>
          </tr>
        </template>
      </tbody>
    </table>
    <b-modal
      id="edit-phone-modal"
      :title="$t('Социальные сети донора')"
      :no-close-on-backdrop="true"
      @keydown.native.enter="save"
      :cancel-disabled="false"
    >
      <rdkm-select
        :label="$t('Социальная сеть')"
        name="social_network_id"
        validate="required"
        :cols="8"
        :labelCols="3"
        :allowEmpty="false"
        v-model="row.social_network_id"
        @input="socialNetworkChanged"
        :options="socialNetworks"
      ></rdkm-select>
      <rdkm-input
        label="Url"
        v-model="row.url"
        :cols="8"
        :labelCols="3"
      ></rdkm-input>
      <rdkm-tweet
        :label="$t('Комментарий')"
        name="comment"
        :cols="8"
        :labelCols="3"
        :maxlength="2000"
        v-model="row.commentary"
      ></rdkm-tweet>
      <div slot="modal-footer" class="w-100">
        <div class="offset-md-3">
          <b-button
            :disabled="errors.any()"
            @click="save"
            size="sm"
            variant="primary"
            class="mr-1"
          >
            <font-awesome-icon icon="check" /> {{ $t("Сохранить") }}
          </b-button>
          <b-button
            @click="hideModal('edit-phone-modal')"
            size="sm"
            variant="default"
          >
            <font-awesome-icon icon="times" /> {{ $t("Отмена") }}
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import GridMixin from "@/components/grid/Grid.mixin";
import ModalMixin from "@/mixins/modal.mixin";

export default {
  name: "DonorSocialNetworks",
  mixins: [GridMixin, ModalMixin],
  props: ["id", "data", "socialNetworks", "isReadonly"],
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  data() {
    return {
      row: {},
      initRow: {
        social_network_id: "",
        social_network_name: "",
        url: "",
        donor_id: "", 
        commentary: "",
      },
      currentIndex: -1,
      renderKey: 0,
    };
  },
  methods: {
    socialNetworkChanged(id) {
      this.row.social_network = null;
      this.row.social_network_name = id
        ? this.socialNetworks.find((t) => t.key == id).value
        : "";
    },
    editRow(index) {
      this.row = Object.assign(
        {},
        index >= 0 ? this.data[index] : this.initRow
      );
      this.currentIndex = index;
      this.showModal("edit-phone-modal");
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.row.donor_id = this.id;
          if (this.currentIndex >= 0) {
            this.data[this.currentIndex] = this.row;
          } else {
            this.data.push(this.row);
          }
          this.renderKey++;
          this.hideModal("edit-phone-modal");
        }
      });
    },
  },
};
</script>
